/**
 * Script para paginação infinita na página de produtos
 * 
 * @package MF_Concessionarias_2025
 */

document.addEventListener('DOMContentLoaded', function() {
    // Inicializar a paginação infinita
    initProdutosInfiniteScroll();
    
    /**
     * Inicializa a paginação infinita
     */
    function initProdutosInfiniteScroll() {
        const loadMoreButton = document.getElementById('load-more-produtos');
        
        if (!loadMoreButton) {
            console.log('Botão de carregar mais não encontrado');
            return;
        }
        
        loadMoreButton.addEventListener('click', function(e) {
            // Se houver filtros ativos na URL, usar o fluxo filtrado por AJAX
            const params = new URLSearchParams(window.location.search);
            const filtrosAtivos = params.has('estado') || params.has('categoria') || params.has('marca');
            if (filtrosAtivos && window.mfLoadMoreFiltrado) {
                e.preventDefault();
                e.stopPropagation();
                window.mfLoadMoreFiltrado('produtos');
                return;
            }
            carregarMaisProdutos();
        });
    }
    
    /**
     * Carrega mais produtos via AJAX
     */
    function carregarMaisProdutos() {
        // Se houver filtros ativos na URL, não usar este fluxo nativo (next_posts_link)
        const params = new URLSearchParams(window.location.search);
        const filtrosAtivos = params.has('estado') || params.has('categoria') || params.has('marca');
        if (filtrosAtivos && window.mfLoadMoreFiltrado) {
            window.mfLoadMoreFiltrado('produtos');
            return;
        }
        const loadMoreButton = document.getElementById('load-more-produtos');
        
        if (!loadMoreButton) {
            console.error('Botão de carregar mais não encontrado');
            return;
        }
        
        // Mostrar loader global
        if (window.MFLoader) {
            // Usar texto traducible desde PHP
            const textoLoader = (typeof mfLoader !== 'undefined' && mfLoader.carregandoProdutos) ? 
                mfLoader.carregandoProdutos : 'Carregando mais produtos...';
            window.MFLoader.show(textoLoader);
        } else {
            // Fallback para o loader antigo
            const loader = document.getElementById('produtos-loader');
            if (loader) {
                loader.classList.remove('hidden');
                loader.classList.add('inline-block');
            }
        }
        
        // Desabilitar o botão enquanto carrega
        loadMoreButton.setAttribute('disabled', 'disabled');
        
        // Buscar el contenedor del enlace oculto de forma más específica
        // Buscar dentro del contenedor #produtos-load-more
        const loadMoreContainer = document.getElementById('produtos-load-more');
        if (!loadMoreContainer) {
            console.error('Container de carregamento não encontrado');
            return;
        }
        
        // Buscar el div oculto que está después del botón
        const hiddenLinkContainer = loadMoreContainer.nextElementSibling;
        
        if (!hiddenLinkContainer || !hiddenLinkContainer.classList.contains('hidden')) {
            console.error('Container de link oculto não encontrado');
            return;
        }
        
        // Obtener el enlace dentro del div oculto
        const hiddenLink = hiddenLinkContainer.querySelector('a');
        
        if (!hiddenLink) {
            console.error('Link oculto não encontrado');
            return;
        }
        
        let nextPageLink = hiddenLink.getAttribute('href');
        
        // Usar a URL original sem modificações
        console.log('URL da próxima página:', nextPageLink);
        
        // Fazer a requisição AJAX
        fetch(nextPageLink)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Imprimir el HTML recibido para depuración (solo los primeros 500 caracteres)
                console.log('HTML recebido (primeiros 500 caracteres):', html.substring(0, 500));
                
                // Buscar todos los posibles contenedores de productos en la página cargada
                console.log('Buscando contenedor de productos...');
                
                // Intentar diferentes selectores para encontrar el contenedor de productos
                let newProductsContainer = doc.querySelector('#produtos-grid');
                
                if (!newProductsContainer) {
                    console.log('Tentando encontrar com outros seletores...');
                    // Intentar con otros selectores posibles
                    const possibleSelectors = [
                        '.grid-produtos',
                        '.produtos-container',
                        '.grid',
                        '.grid-cols-1',
                        'div[id*="produtos"]',
                        'div[class*="grid"]'
                    ];
                    
                    for (const selector of possibleSelectors) {
                        const container = doc.querySelector(selector);
                        if (container) {
                            console.log(`Contenedor encontrado con selector alternativo: ${selector}`);
                            newProductsContainer = container;
                            break;
                        }
                    }
                }
                
                // Si aún no encontramos el contenedor, buscar cualquier elemento que contenga productos
                if (!newProductsContainer) {
                    // Buscar directamente los productos
                    const produtos = doc.querySelectorAll('.produto-card');
                    if (produtos.length > 0) {
                        console.log('Produtos encontrados diretamente, criando container virtual');
                        // Crear un contenedor virtual
                        newProductsContainer = document.createElement('div');
                        produtos.forEach(produto => {
                            newProductsContainer.appendChild(produto);
                        });
                    } else {
                        console.error('Container de produtos não encontrado na página carregada');
                        // Habilitar el botón nuevamente
                        loadMoreButton.removeAttribute('disabled');
                        // Ocultar el loader
                        if (loader) {
                            loader.classList.add('hidden');
                            loader.classList.remove('inline-block');
                        }
                        return;
                    }
                }
                
                // Usar o seletor correto para encontrar os produtos
                // Selecionar elementos com classe 'produto-card' que são filhos diretos do container
                let newProducts = newProductsContainer.querySelectorAll('.produto-card');
                
                // Si no encontramos productos con la clase 'produto-card', intentar con otros selectores
                if (!newProducts || newProducts.length === 0) {
                    console.log('Tentando encontrar produtos com outros seletores...');
                    const possibleProductSelectors = [
                        '.card',
                        '.produto',
                        'article',
                        'div[data-produto-id]',
                        'div[class*="produto"]'
                    ];
                    
                    for (const selector of possibleProductSelectors) {
                        const produtos = newProductsContainer.querySelectorAll(selector);
                        if (produtos && produtos.length > 0) {
                            console.log(`Produtos encontrados com selector alternativo: ${selector}`);
                            newProducts = produtos;
                            break;
                        }
                    }
                }
                
                console.log('Produtos encontrados na próxima página:', newProducts.length);
                
                // Buscar el contenedor de productos en la página actual
                let productsContainer = document.querySelector('#produtos-grid');
                
                // Si no encontramos el contenedor con el ID, intentar con otros selectores
                if (!productsContainer) {
                    console.log('Tentando encontrar container atual com outros seletores...');
                    const possibleContainerSelectors = [
                        '.grid-produtos',
                        '.produtos-container',
                        '.grid',
                        '.grid-cols-1',
                        'div[id*="produtos"]',
                        'div[class*="grid"]'
                    ];
                    
                    for (const selector of possibleContainerSelectors) {
                        const container = document.querySelector(selector);
                        if (container) {
                            console.log(`Container atual encontrado com selector alternativo: ${selector}`);
                            productsContainer = container;
                            break;
                        }
                    }
                }
                
                if (!productsContainer) {
                    console.error('Container de produtos não encontrado na página atual');
                    // Habilitar el botón nuevamente
                    loadMoreButton.removeAttribute('disabled');
                    // Ocultar el loader
                    if (loader) {
                        loader.classList.add('hidden');
                        loader.classList.remove('inline-block');
                    }
                    return;
                }
                
                const existingProductIds = new Set();
                
                // Coletar IDs de produtos existentes para evitar duplicação
                document.querySelectorAll('.produto-card').forEach(product => {
                    const productId = product.getAttribute('data-produto-id');
                    if (productId) {
                        existingProductIds.add(productId);
                    }
                });
                
                console.log('Total de produtos existentes:', existingProductIds.size);
                
                // Adicionar apenas produtos não duplicados
                let produtosAdicionados = 0;
                let produtosIgnorados = 0;
                
                newProducts.forEach(product => {
                    const productId = product.getAttribute('data-produto-id');
                    
                    if (!productId) {
                        console.warn('Produto sem ID encontrado, ignorando...');
                        return;
                    }
                    
                    if (!existingProductIds.has(productId)) {
                        // Adicionar o produto ao container
                        productsContainer.appendChild(product.cloneNode(true));
                        // Adicionar o ID à lista de IDs existentes para evitar duplicação futura
                        existingProductIds.add(productId);
                        produtosAdicionados++;
                    } else {
                        produtosIgnorados++;
                    }
                });
                
                console.log('Produtos adicionados:', produtosAdicionados);
                console.log('Produtos ignorados (duplicados):', produtosIgnorados);
                
                // Inicializar os toggles para os novos produtos
                initProdutoToggles();
                
                // Extraer información de paginación de la respuesta
                const paginationInfo = extractPaginationInfo(doc);
                console.log('Informação de paginação:', paginationInfo);
                
                // Buscar todos los divs ocultos en la nueva página
                const allHiddenDivs = doc.querySelectorAll('div.hidden');
                console.log('Divs ocultos encontrados na nova página:', allHiddenDivs.length);
                
                let nextLinkContainer = null;
                
                // Buscar el div oculto que contiene el enlace de paginación
                for (let i = 0; i < allHiddenDivs.length; i++) {
                    const div = allHiddenDivs[i];
                    const link = div.querySelector('a');
                    if (link) {
                        const href = link.getAttribute('href');
                        console.log(`Div oculto ${i+1} contém link:`, href);
                        if (href && href.includes('page')) {
                            nextLinkContainer = div;
                            break;
                        }
                    }
                }
                
                // Buscar el contenedor del enlace oculto en la página actual
                const loadMoreContainer = document.getElementById('produtos-load-more');
                let hiddenLinkContainer = null;
                
                // Buscar el div oculto que contiene el enlace de paginación en la página actual
                const currentHiddenDivs = document.querySelectorAll('div.hidden');
                console.log('Divs ocultos encontrados na página atual:', currentHiddenDivs.length);
                
                for (let i = 0; i < currentHiddenDivs.length; i++) {
                    const div = currentHiddenDivs[i];
                    const link = div.querySelector('a');
                    if (link) {
                        const href = link.getAttribute('href');
                        console.log(`Div oculto atual ${i+1} contém link:`, href);
                        if (href && href.includes('page')) {
                            hiddenLinkContainer = div;
                            break;
                        }
                    }
                }
                
                // Función para extraer información de paginación
                function extractPaginationInfo(doc) {
                    // Intentar encontrar información de paginación en el HTML
                    const totalPosts = doc.querySelector('.text-sm.text-neutral');
                    const currentPage = new URL(nextPageLink).searchParams.get('paged') || '1';
                    return {
                        totalPosts: totalPosts ? totalPosts.textContent.trim() : 'Desconhecido',
                        currentPage: currentPage
                    };
                }
                
                console.log('Container de link encontrado na nova página:', !!nextLinkContainer);
                console.log('Container de link encontrado na página atual:', !!hiddenLinkContainer);
                
                if (nextLinkContainer && hiddenLinkContainer) {
                    const nextLinkElement = nextLinkContainer.querySelector('a');
                    const hiddenLinkElement = hiddenLinkContainer.querySelector('a');
                    
                    if (nextLinkElement && nextLinkElement.getAttribute('href') && hiddenLinkElement) {
                        // Atualizar o link para a próxima página
                        const novoLink = nextLinkElement.getAttribute('href');
                        console.log('Atualizando link para próxima página:', novoLink);
                        hiddenLinkElement.setAttribute('href', novoLink);
                        
                        // Habilitar o botão novamente
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        console.log('Não há mais páginas para carregar (link não encontrado)');
                        // Se não houver mais páginas, ocultar o botão
                        loadMoreButton.style.display = 'none';
                    }
                } else {
                    console.log('Não há mais páginas para carregar (container não encontrado)');
                    // Se não houver mais páginas, ocultar o botão
                    loadMoreButton.style.display = 'none';
                }
                
                // Esconder o loader global
                if (window.MFLoader) {
                    window.MFLoader.hide();
                } else if (loader) {
                    // Fallback para o loader antigo
                    loader.classList.add('hidden');
                    loader.classList.remove('inline-block');
                }
            })
            .catch(error => {
                console.error('Erro ao carregar mais produtos:', error);
                
                // Habilitar o botão novamente em caso de erro
                loadMoreButton.removeAttribute('disabled');
                
                // Esconder o loader global
                if (window.MFLoader) {
                    window.MFLoader.hide();
                } else {
                    const loader = document.getElementById('produtos-loader');
                    if (loader) {
                        loader.classList.add('hidden');
                        loader.classList.remove('inline-block');
                    }
                }
            });
    }
    
    /**
     * Inicializa os toggles para mostrar/ocultar informações dos produtos
     */
    function initProdutoToggles() {
        document.querySelectorAll('.toggle-produto-info').forEach(toggle => {
            if (!toggle.hasEventListener) {
                toggle.addEventListener('click', function() {
                    const produtoId = this.closest('.produto-header').getAttribute('data-produto-id');
                    const infoContainer = document.getElementById('produto-info-' + produtoId.replace('produto-', ''));
                    const icon = this.querySelector('.toggle-icon');
                    
                    if (infoContainer) {
                        if (infoContainer.style.display === 'none') {
                            infoContainer.style.display = 'block';
                            icon.classList.remove('bi-chevron-down');
                            icon.classList.add('bi-chevron-up');
                        } else {
                            infoContainer.style.display = 'none';
                            icon.classList.remove('bi-chevron-up');
                            icon.classList.add('bi-chevron-down');
                        }
                    }
                });
                toggle.hasEventListener = true;
            }
        });
    }
    
    // Inicializar os toggles para os produtos iniciais
    initProdutoToggles();
});
